import React from 'react';
import { useMutation } from 'urql';

import Button from 'components/Button';
import CopyToClipboardTextInput from 'components/Form/Inputs/CopyToClipboardTextInput';
import Modal from 'components/Modal';

import { GrantArchiveAccess } from './graphql';
import { useLabelSubscribersContext } from './LabelSubscribersContext';
import { TextEmphasis } from '@protonradio/proton-ui';

const ConfirmArchiveAccessModal = () => {
  const { confirmationModal, setConfirmationModal, label } = useLabelSubscribersContext();
  const [{ fetching: isSubmitting, data: success }, grantAccess] =
    useMutation(GrantArchiveAccess);

  if (!confirmationModal || confirmationModal.type !== 'archive-access') return null;
  const { artist } = confirmationModal;
  const close = () => setConfirmationModal(null);

  if (success) {
    return (
      <Modal
        title="Archive Access Granted!"
        subtitle={
          <>
            The DJ can now download your back catalog for a full month. Send them the URL
            below, so they can start crate digging + downloading.
          </>
        }
        onClose={close}
        frozen={isSubmitting}
      >
        <div data-testid={TEST_IDS.CONFIRMATION_MODAL}>
          <CopyToClipboardTextInput
            className="mt-3"
            text={`${window.origin}${label.slug}/tracks`}
            testId={TEST_IDS.CONFIRMATION_MODAL_LINK}
          />
        </div>
      </Modal>
    );
  }

  return (
    <Modal
      title="Archive Access"
      subtitle={
        <div>
          <TextEmphasis>{artist!.name}</TextEmphasis> will be given full access to
          download <strong>{label.name}</strong>&apos;s back catalog for one month. Are
          you sure?
        </div>
      }
      onClose={close}
    >
      <Modal.ButtonGroup>
        <Button disabled={isSubmitting} color={Button.COLORS.NEUTRAL} onClick={close}>
          Cancel
        </Button>
        <Button
          disabled={isSubmitting}
          data-testid={TEST_IDS.CONFIRM_ACCESS_BUTTON}
          onClick={() => grantAccess({ labelId: label.id, artistId: artist!.id })}
        >
          Grant Access
        </Button>
      </Modal.ButtonGroup>
    </Modal>
  );
};

const TEST_IDS = {
  CONFIRM_ACCESS_BUTTON: 'grant-archive-access-confirm-button',
  CONFIRMATION_MODAL: 'grant-archive-access-confirmation-modal',
  CONFIRMATION_MODAL_LINK: 'grant-archive-access-confirmation-link'
};

ConfirmArchiveAccessModal.TEST_IDS = TEST_IDS;

export default ConfirmArchiveAccessModal;
